import _ from 'lodash';

export default {
    data() {
        return {
            form: null,
            item: null,
            keyForm: 1,
            loading: false,
            moduleActions: [],
            help: '',
            hashValue: ''
        }
    },
    props: ['itemId'],
    mounted() {
        // this.setRules();
        this.loadItem();
    },
    methods: {
        cancel() {
            this.$router.go(-1);
        },
        hasChanges() {
            let hasOld = (JSON.stringify(this.form)).hashCode();
            return hasOld !== this.hashValue;
        },
        hasChanged(oldValue, newValue) {
            if ((!oldValue && newValue) || (oldValue && !newValue)) {
                return true;
            }
            if(newValue && newValue.id && oldValue && oldValue.id && oldValue.id != newValue.id){
                return true;
            }
            return !_.isEqual(oldValue, newValue);
        },
        can(actions, name) {

            if(typeof actions == 'string'){
              if(!this.item){
                  return true;
              }
              if(this.item._actions.length > 0 && this.item._actions.indexOf(actions) >= 0){
                return true;
              }
              if(this.moduleActions.length > 0 && this.moduleActions.indexOf(actions) >= 0){
                return true;
              }
              return false;
            }else{
              if(actions && actions.length > 0 && actions.indexOf(name) >= 0){
                return true;
              }
              return false;
            }
        },
        setTitle(){
            if(this.item){
                if(this.item.name){
                    return this.item.name;
                }
                if(this.item.id){
                    return this.item.id;
                }
            }
            return 'Actualizar';
        },
        loadItem() {
            if (this.$route.params.id || this.itemId) {
                const id = this.itemId || this.$route.params.id;
                this.getItem(id).then(data => {
                    this.setItem(data.item);
                });
            }
        },
        setItem(item){
            this.item = item;
            this.setTitle();
            this.loadForm(this.item);
        },
        loadForm(item) {
            this.form = { ...item };
            this.hashValue = this.getHashValue(this.form);
        },
        getHashValue(value){
            return (JSON.stringify(value)).hashCode();
        },
        getUrlGet() {
            return this.urlGet;
        },
        getItem(id) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                this.$http.get(this.getUrlGet() + '/' + id)
                    .then(data => {
                        let { item } = data;
                        this.moduleActions = data.module_actions;
                        this.loading = false;
                        resolve({ item });
                    }).catch(err => {
                        this.loading = false;
                    }).finally(() => (this.loading = false));
            });
        },
        clean() {
            this.form = {};
        },
        async clear() {
            //this.name = this.email = this.select = this.checkbox = "";
            this.$nextTick(() => {
                this.$refs.form.reset();
            });
        },
        async validateForm() {
            return await this.$refs.obs.validate();
        },
        executeModuleAction(name) {
        },
        executeItemAction(name) {

        },
        isDisabledBtn(name) {

            return false;
        }
    }
}
